import { render, staticRenderFns } from "./DocumentThumbnailView.vue?vue&type=template&id=28cad059"
import script from "./DocumentThumbnailView.vue?vue&type=script&lang=js"
export * from "./DocumentThumbnailView.vue?vue&type=script&lang=js"
import style0 from "./DocumentThumbnailView.vue?vue&type=style&index=0&id=28cad059&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports